/* eslint-disable no-param-reassign */
class Collection {
	constructor() {
		this.currencySymbol = "£";
		this.init();
	}

	// eslint-disable-next-line class-methods-use-this
	redirectSort(newSort) {
		const url = new URL(window.location.href);
		const { pathname, search } = url;
		const currentSort = pathname.split("/")[3];

		if (currentSort === newSort) return;

		let newLocation;

		if (currentSort) {
			const newPath = pathname.replace(currentSort, newSort).replace("//", "/");
			newLocation = new URL(`${url.origin}${newPath}${search}`);
		} else {
			const delimiter = pathname.charAt(pathname.length - 1) === "/" ? "" : "/";
			newLocation = new URL(`${url.origin}${pathname}${delimiter}${newSort}/${search}`);
		}

		window.location.href = newLocation;
	}

	handleReset() {
		this.filterResetBtns.forEach((resetBtn) => {
			resetBtn.addEventListener("click", () => {
				this.filterGroups.forEach((filterGroup) => {
					const filterValues = Array.from(filterGroup.querySelectorAll("[data-filter-value]"));
					filterValues.forEach((filterValue) => {
						filterValue.checked = false;
					});
					filterGroup.removeAttribute("data-filter-active");
				});
				this.filtersChanged();
			});
		});
	}

	filtersChanged() {
		this.updateMobileActiveIcon();
		this.updateProductList();
		this.updateUrl();
		this.updateProductNumber();
		this.checkedInGroup();
		this.updateFilters();
		// this.setFiltersFromUrl()
	}

	parsePriceRange(filterValue) {
		const priceRange = { minimum: undefined, maximum: undefined };
		if (filterValue.startsWith("Up to")) {
			priceRange.minimum = 0;
			priceRange.maximum = +filterValue.split(this.currencySymbol)[1];
		} else if (filterValue.startsWith("Over")) {
			priceRange.minimum = +filterValue.split(this.currencySymbol)[1];
			priceRange.maximum = Infinity;
		} else {
			const [minPrice, maxPrice] = filterValue.split(" to ");

			priceRange.minimum = +minPrice.split("£")[1];
			priceRange.maximum = +maxPrice.split("£")[1];
		}
		return priceRange;
	}

	updateFilters() {
		this.filterGroups.forEach((group) => {
			const filterGroupKey = group.dataset.filterGroup;
			const values = Array.from(group.querySelectorAll("li"));
			values.forEach((value) => {
				const inputElement = value.querySelector("[data-filter-value]");
				const valueName = inputElement.dataset.filterValue; // eg. indoor
				const productCountElement = value.querySelector("[data-filter-value-count]"); // num items
				const productCount = this.filteredProducts.reduce((prev, curr) => {
					const productFilters = JSON.parse(curr.dataset.filters);
					if (productFilters[filterGroupKey] && productFilters[filterGroupKey].includes(valueName)) {
						return prev + 1;
					}

					if (filterGroupKey === "price") {
						const priceAsNumber = Number(productFilters[filterGroupKey]);
						const priceRange = this.parsePriceRange(valueName);
						if (priceAsNumber >= priceRange.minimum && priceAsNumber < priceRange.maximum) {
							return prev + 1;
						}
						return prev;
					}

					return prev;
				}, 0);

				productCountElement.innerText = productCount;
				value.toggleAttribute("hidden", productCount === 0);
			});
			const nonHiddenValues = values.some((value) => value.getAttribute("hidden") === null);
			group.toggleAttribute("hidden", !nonHiddenValues);
		});
	}

	updateProductNumber() {
		this.productNumberDisplay.forEach((ele) => {
			ele.innerText = this.productNumber;
		});
	}

	updateMobileActiveIcon() {
		this.mobileFilterActive.toggleAttribute("hidden", Object.keys(this.activeFilters).length === 0);
	}

	checkedInGroup(filterGroup, filterValues) {
		if (filterGroup) {
			const values = filterValues || Array.from(filterGroup.querySelectorAll("[data-filter-value]"));
			const checkedInGroup = values.some((input) => input.checked);
			filterGroup.toggleAttribute("data-filter-active", checkedInGroup);
		} else {
			this.filterGroups.forEach((group) => {
				this.checkedInGroup(group);
			});
		}
	}

	handleFilters() {
		this.mobileFilterToggles.forEach((toggle) => {
			toggle.addEventListener("click", () => {
				const isExpanded = this.mobileFilter.getAttribute("aria-expanded") === "true";
				this.mobileFilter.setAttribute("aria-expanded", `${!isExpanded}`);
				this.mobileFilter.classList.toggle("invisible", isExpanded);

				document.documentElement.classList.toggle("overflow-hidden", !isExpanded);
			});
		});
		this.filterGroups.forEach((filterGroup) => {
			const filterToggleButton = filterGroup.querySelector("[data-filter-group-toggle]");
			filterToggleButton.addEventListener("click", () => filterGroup.toggleAttribute("open"));

			const filterValues = Array.from(filterGroup.querySelectorAll("[data-filter-value]"));
			filterValues.forEach((filterValue) => {
				filterValue.addEventListener("change", ({ target }) => {
					const filterPair = this.rootElement.querySelectorAll(`[data-filter-value="${target.dataset.filterValue}"]`);
					filterPair.forEach((filter) => {
						filter.checked = target.checked;
					});
					this.checkedInGroup(filterGroup, filterValues);
					this.filtersChanged();
				});
			});
		});
	}

	get activeFilters() {
		return this.filterGroups.reduce((prev, curr) => {
			const activeFiltersInGroup = Array.from(curr.querySelectorAll("[data-filter-value]"))
				.filter((filterValue) => filterValue.checked)
				.map((filterValue) => filterValue.dataset.filterValue);

			if (activeFiltersInGroup.length === 0) return prev;

			return { ...prev, [curr.dataset.filterGroup]: activeFiltersInGroup };
		}, {});
	}

	get productNumber() {
		return this.filteredProducts.length;
	}

	updateProductList() {
		this.filteredProducts.forEach((product) => product.setAttribute("hidden", "hidden"));
		this.filteredProducts = this.allProducts.filter((product) =>
			Object.entries(this.activeFilters).every(([group, value]) => {
				const productFilters = JSON.parse(product.dataset.filters); // {}
				if (!productFilters[group]) return false;

				if (group === "price") {
					const priceRange = this.parsePriceRange(value[0]);
					const priceAsNumber = Number(productFilters[group]);
					return priceAsNumber >= priceRange.minimum && priceAsNumber < priceRange.maximum;
				}

				return productFilters[group].find((v) => value.includes(v)) || false;
			})
		);

		this.filteredProducts.forEach((product) => product.removeAttribute("hidden"));
	}

	handleSortToggle() {
		if (!this.sortOptions || !this.sortToggle || !this.mobileSortToggle) return;

		window.addEventListener("click", ({ target }) => {
			if (!target.closest("[data-collection] [data-sort-toggle]")) {
				this.sortToggle.removeAttribute("open");
			} else {
				this.sortToggle.toggleAttribute("open");
			}
		});
		this.mobileSortToggle.addEventListener("change", ({ target: { value } }) => {
			this.redirectSort(value);
		});
		this.sortOptions.forEach((opt) => {
			opt.addEventListener("click", ({ currentTarget }) => {
				this.redirectSort(currentTarget.getAttribute("data-sort-option"));
			});
		});
	}

	getSortOption() {
		if (!this.sortOptions || !this.sortToggle || !this.mobileSortToggle) return;
		const activeSortValue = window.location.pathname.split("/")[3] || "";
		const activeSortOption =
			this.sortOptions.find((sortOption) => sortOption.dataset.sortOption === activeSortValue) || this.sortOptions[0];
		Array.from(this.mobileSortToggle.querySelectorAll("option"))
			.find((option) => option.value === activeSortValue)
			.setAttribute("selected", "");

		this.sortToggle.querySelector("[data-active-sort]").innerText = activeSortOption.innerText;

		this.mobileSortActive.toggleAttribute("hidden", !activeSortValue);
	}

	setFiltersFromUrl() {
		const url = new URL(window.location.href);
		const searchParams = new URLSearchParams(url.search);
		Array.from(searchParams.entries()).forEach(([activeGroup, activeValue]) => {
			const filterGroup = this.filterGroups.filter((group) => group.dataset.filterGroup === activeGroup);
			if (filterGroup.length === 0) return;
			filterGroup.forEach((group) => {
				const filterValue = Array.from(group.querySelectorAll("[data-filter-value]")).find(
					(value) => value.dataset.filterValue === activeValue
				);
				if (!filterValue) return;
				filterValue.checked = true;
			});
		});
	}

	updateUrl() {
		const url = new URL(window.location.href);
		this.filterGroups.forEach((group) => {
			url.searchParams.delete(group.dataset.filterGroup);
		});
		Object.entries(this.activeFilters).forEach(([key, values]) => {
			values.forEach((value) => {
				url.searchParams.append(key, value);
			});
		});
		window.history.replaceState(null, null, url);
	}

	handleSubheader() {
		if (this.readMoreToggles.length === 0) return;
		this.readMoreToggles.forEach((toggle) => {
			toggle.addEventListener("click", () => {
				const readMoreTarget = toggle.dataset.readMoreToggle;
				if (!readMoreTarget) return;
				const readMoreTargetElement = document.querySelector(`#${readMoreTarget}`);
				if (!readMoreTargetElement) return;
				this.readMoreToggles.forEach((otherToggle) => {
					otherToggle.removeAttribute("hidden");
				});
				toggle.setAttribute("hidden", "hidden");
				readMoreTargetElement.toggleAttribute("hidden");
			});
		});
	}

	init() {
		this.rootElement = document.querySelector("[data-collection]");
		// Filtering
		this.filterElement = this.rootElement.querySelector("[data-collection-filter]");
		this.filterResetBtns = Array.from(this.rootElement.querySelectorAll("[data-reset]"));
		this.filterGroups = Array.from(this.rootElement.querySelectorAll("[data-filter-group]"));
		this.mobileFilter = this.rootElement.querySelector("[data-collection-filter-mobile]");
		this.mobileFilterToggles = this.rootElement.querySelectorAll("[data-mobile-filter-toggle]");
		this.mobileFilterActive = this.rootElement.querySelector("[data-mobile-filter-active]");
		this.productNumberDisplay = Array.from(this.rootElement.querySelectorAll("[data-product-number]"));

		// Sorting
		this.sortToggle = this.rootElement.querySelector("[data-sort-toggle]");
		this.mobileSortToggle = this.rootElement.querySelector("[data-mobile-sort-toggle]");
		this.mobileSortActive = this.rootElement.querySelector("[data-mobile-sort-active]");
		this.sortOptions = Array.from(this.rootElement.querySelectorAll("[data-sort-option]"));

		this.allProducts = Array.from(this.rootElement.querySelectorAll("article[data-card]"));
		this.filteredProducts = [...this.allProducts];

		this.readMoreToggles = document.querySelectorAll("[data-read-more-toggle]");
		// Setting data to correct values from url & search params
		this.getSortOption();
		this.setFiltersFromUrl();

		// Updating DOM based on filters
		this.filtersChanged();

		// Adding event listeners
		this.handleFilters();
		this.handleReset();
		this.handleSortToggle();
		this.handleSubheader();
	}
}

// eslint-disable-next-line no-new
window.patchCollection = new Collection();
